/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CodeInformation,
  CreateAdministratorUserRequest,
  ErrorResponse,
  LoginRequest,
  LoginSuccessfulResponse,
  PasswordResetRequest,
  PostApiAdministratorusersCompaniesCompanyIdInvoicesParams,
  PostApiAuthRefreshCompanyParams,
  ProblemDetails,
  RefreshAccessTokenRequest,
  RegisterEmployeeUserByRegistrationCodeRequest,
  ResetPasswordWithTokenRequest,
  SeedRequest,
  SeedResponse
} from '../../model';

import { axiosInstance } from '../../axios-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postApiLogin = (
    loginRequest?: LoginRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<LoginSuccessfulResponse>(
      {url: `/api/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginRequest, signal
    },
      );
    }




export const getPostApiLoginMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLogin>>, TError,{data?: LoginRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiLogin>>, TError,{data?: LoginRequest}, TContext> => {

const mutationKey = ['postApiLogin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiLogin>>, {data?: LoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiLogin(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postApiLogin>>>
    export type PostApiLoginMutationBody = LoginRequest | undefined
    export type PostApiLoginMutationError = ErrorResponse

    export const usePostApiLogin = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLogin>>, TError,{data?: LoginRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiLogin>>,
        TError,
        {data?: LoginRequest},
        TContext
      > => {
      return useMutation(getPostApiLoginMutationOptions(options), queryClient);
    }
    export const postApiAuthRefreshCompany = (
    params?: PostApiAuthRefreshCompanyParams,
 signal?: AbortSignal
) => {


      return axiosInstance<LoginSuccessfulResponse>(
      {url: `/api/auth/refresh/company`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAuthRefreshCompanyMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuthRefreshCompany>>, TError,{params?: PostApiAuthRefreshCompanyParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAuthRefreshCompany>>, TError,{params?: PostApiAuthRefreshCompanyParams}, TContext> => {

const mutationKey = ['postApiAuthRefreshCompany'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAuthRefreshCompany>>, {params?: PostApiAuthRefreshCompanyParams}> = (props) => {
          const {params} = props ?? {};

          return  postApiAuthRefreshCompany(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAuthRefreshCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAuthRefreshCompany>>>

    export type PostApiAuthRefreshCompanyMutationError = ErrorResponse

    export const usePostApiAuthRefreshCompany = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuthRefreshCompany>>, TError,{params?: PostApiAuthRefreshCompanyParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAuthRefreshCompany>>,
        TError,
        {params?: PostApiAuthRefreshCompanyParams},
        TContext
      > => {
      return useMutation(getPostApiAuthRefreshCompanyMutationOptions(options), queryClient);
    }
    export const postApiAuthRefresh = (
    refreshAccessTokenRequest?: RefreshAccessTokenRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<LoginSuccessfulResponse>(
      {url: `/api/auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshAccessTokenRequest, signal
    },
      );
    }




export const getPostApiAuthRefreshMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuthRefresh>>, TError,{data?: RefreshAccessTokenRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAuthRefresh>>, TError,{data?: RefreshAccessTokenRequest}, TContext> => {

const mutationKey = ['postApiAuthRefresh'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAuthRefresh>>, {data?: RefreshAccessTokenRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiAuthRefresh(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAuthRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAuthRefresh>>>
    export type PostApiAuthRefreshMutationBody = RefreshAccessTokenRequest | undefined
    export type PostApiAuthRefreshMutationError = ErrorResponse

    export const usePostApiAuthRefresh = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuthRefresh>>, TError,{data?: RefreshAccessTokenRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAuthRefresh>>,
        TError,
        {data?: RefreshAccessTokenRequest},
        TContext
      > => {
      return useMutation(getPostApiAuthRefreshMutationOptions(options), queryClient);
    }
    export const postApiSeeding = (
    seedRequest?: SeedRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<SeedResponse>(
      {url: `/api/seeding`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: seedRequest, signal
    },
      );
    }




export const getPostApiSeedingMutationOptions = <TError = ErrorResponse | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSeeding>>, TError,{data?: SeedRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiSeeding>>, TError,{data?: SeedRequest}, TContext> => {

const mutationKey = ['postApiSeeding'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSeeding>>, {data?: SeedRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSeeding(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSeedingMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSeeding>>>
    export type PostApiSeedingMutationBody = SeedRequest | undefined
    export type PostApiSeedingMutationError = ErrorResponse | ProblemDetails

    export const usePostApiSeeding = <TError = ErrorResponse | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSeeding>>, TError,{data?: SeedRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSeeding>>,
        TError,
        {data?: SeedRequest},
        TContext
      > => {
      return useMutation(getPostApiSeedingMutationOptions(options), queryClient);
    }
    export const postApiLoginDemoDemoCode = (
    demoCode: string,
 signal?: AbortSignal
) => {


      return axiosInstance<LoginSuccessfulResponse>(
      {url: `/api/login/demo/${demoCode}`, method: 'POST', signal
    },
      );
    }




export const getPostApiLoginDemoDemoCodeMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLoginDemoDemoCode>>, TError,{demoCode: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiLoginDemoDemoCode>>, TError,{demoCode: string}, TContext> => {

const mutationKey = ['postApiLoginDemoDemoCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiLoginDemoDemoCode>>, {demoCode: string}> = (props) => {
          const {demoCode} = props ?? {};

          return  postApiLoginDemoDemoCode(demoCode,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiLoginDemoDemoCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiLoginDemoDemoCode>>>

    export type PostApiLoginDemoDemoCodeMutationError = ErrorResponse

    export const usePostApiLoginDemoDemoCode = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiLoginDemoDemoCode>>, TError,{demoCode: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiLoginDemoDemoCode>>,
        TError,
        {demoCode: string},
        TContext
      > => {
      return useMutation(getPostApiLoginDemoDemoCodeMutationOptions(options), queryClient);
    }
    export const postApiUsersUserIdConfirmationToken = (
    userId: string,
    token: string,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/users/${userId}/confirmation/${token}`, method: 'POST', signal
    },
      );
    }




export const getPostApiUsersUserIdConfirmationTokenMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdConfirmationToken>>, TError,{userId: string;token: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdConfirmationToken>>, TError,{userId: string;token: string}, TContext> => {

const mutationKey = ['postApiUsersUserIdConfirmationToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersUserIdConfirmationToken>>, {userId: string;token: string}> = (props) => {
          const {userId,token} = props ?? {};

          return  postApiUsersUserIdConfirmationToken(userId,token,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUsersUserIdConfirmationTokenMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersUserIdConfirmationToken>>>

    export type PostApiUsersUserIdConfirmationTokenMutationError = ErrorResponse

    export const usePostApiUsersUserIdConfirmationToken = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersUserIdConfirmationToken>>, TError,{userId: string;token: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUsersUserIdConfirmationToken>>,
        TError,
        {userId: string;token: string},
        TContext
      > => {
      return useMutation(getPostApiUsersUserIdConfirmationTokenMutationOptions(options), queryClient);
    }
    export const postApiUsersPasswordReset = (
    passwordResetRequest?: PasswordResetRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/users/password_reset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordResetRequest, signal
    },
      );
    }




export const getPostApiUsersPasswordResetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersPasswordReset>>, TError,{data?: PasswordResetRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersPasswordReset>>, TError,{data?: PasswordResetRequest}, TContext> => {

const mutationKey = ['postApiUsersPasswordReset'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersPasswordReset>>, {data?: PasswordResetRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiUsersPasswordReset(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUsersPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersPasswordReset>>>
    export type PostApiUsersPasswordResetMutationBody = PasswordResetRequest | undefined
    export type PostApiUsersPasswordResetMutationError = unknown

    export const usePostApiUsersPasswordReset = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersPasswordReset>>, TError,{data?: PasswordResetRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUsersPasswordReset>>,
        TError,
        {data?: PasswordResetRequest},
        TContext
      > => {
      return useMutation(getPostApiUsersPasswordResetMutationOptions(options), queryClient);
    }
    export const postApiUsersPasswordResetToken = (
    token: string,
    resetPasswordWithTokenRequest?: ResetPasswordWithTokenRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/users/password_reset/${token}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordWithTokenRequest, signal
    },
      );
    }




export const getPostApiUsersPasswordResetTokenMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersPasswordResetToken>>, TError,{token: string;data?: ResetPasswordWithTokenRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersPasswordResetToken>>, TError,{token: string;data?: ResetPasswordWithTokenRequest}, TContext> => {

const mutationKey = ['postApiUsersPasswordResetToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersPasswordResetToken>>, {token: string;data?: ResetPasswordWithTokenRequest}> = (props) => {
          const {token,data} = props ?? {};

          return  postApiUsersPasswordResetToken(token,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiUsersPasswordResetTokenMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersPasswordResetToken>>>
    export type PostApiUsersPasswordResetTokenMutationBody = ResetPasswordWithTokenRequest | undefined
    export type PostApiUsersPasswordResetTokenMutationError = ErrorResponse

    export const usePostApiUsersPasswordResetToken = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersPasswordResetToken>>, TError,{token: string;data?: ResetPasswordWithTokenRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUsersPasswordResetToken>>,
        TError,
        {token: string;data?: ResetPasswordWithTokenRequest},
        TContext
      > => {
      return useMutation(getPostApiUsersPasswordResetTokenMutationOptions(options), queryClient);
    }
    export const postApiEmployeeRegistrationCode = (
    registrationCode: string,
    registerEmployeeUserByRegistrationCodeRequest?: RegisterEmployeeUserByRegistrationCodeRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<LoginSuccessfulResponse>(
      {url: `/api/employee/${registrationCode}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerEmployeeUserByRegistrationCodeRequest, signal
    },
      );
    }




export const getPostApiEmployeeRegistrationCodeMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmployeeRegistrationCode>>, TError,{registrationCode: string;data?: RegisterEmployeeUserByRegistrationCodeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiEmployeeRegistrationCode>>, TError,{registrationCode: string;data?: RegisterEmployeeUserByRegistrationCodeRequest}, TContext> => {

const mutationKey = ['postApiEmployeeRegistrationCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiEmployeeRegistrationCode>>, {registrationCode: string;data?: RegisterEmployeeUserByRegistrationCodeRequest}> = (props) => {
          const {registrationCode,data} = props ?? {};

          return  postApiEmployeeRegistrationCode(registrationCode,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiEmployeeRegistrationCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiEmployeeRegistrationCode>>>
    export type PostApiEmployeeRegistrationCodeMutationBody = RegisterEmployeeUserByRegistrationCodeRequest | undefined
    export type PostApiEmployeeRegistrationCodeMutationError = ErrorResponse

    export const usePostApiEmployeeRegistrationCode = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmployeeRegistrationCode>>, TError,{registrationCode: string;data?: RegisterEmployeeUserByRegistrationCodeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiEmployeeRegistrationCode>>,
        TError,
        {registrationCode: string;data?: RegisterEmployeeUserByRegistrationCodeRequest},
        TContext
      > => {
      return useMutation(getPostApiEmployeeRegistrationCodeMutationOptions(options), queryClient);
    }
    export const getApiEmployeeRegistrationcodesRegistrationCode = (
    registrationCode: string,
 signal?: AbortSignal
) => {


      return axiosInstance<CodeInformation>(
      {url: `/api/employee/registrationcodes/${registrationCode}`, method: 'GET', signal
    },
      );
    }




export const getGetApiEmployeeRegistrationcodesRegistrationCodeQueryKey = (registrationCode: string,) => {
    return [
    `/api/employee/registrationcodes/${registrationCode}`
    ] as const;
    }


export const getGetApiEmployeeRegistrationcodesRegistrationCodeQueryOptions = <TData = Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(registrationCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiEmployeeRegistrationcodesRegistrationCodeQueryKey(registrationCode);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>> = ({ signal }) => getApiEmployeeRegistrationcodesRegistrationCode(registrationCode, signal);





   return  { queryKey, queryFn, enabled: registrationCode !== null && registrationCode !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiEmployeeRegistrationcodesRegistrationCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>>
export type GetApiEmployeeRegistrationcodesRegistrationCodeQueryError = ErrorResponse


export function useGetApiEmployeeRegistrationcodesRegistrationCode<TData = Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(
 registrationCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>,
          TError,
          Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiEmployeeRegistrationcodesRegistrationCode<TData = Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(
 registrationCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>,
          TError,
          Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiEmployeeRegistrationcodesRegistrationCode<TData = Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(
 registrationCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiEmployeeRegistrationcodesRegistrationCode<TData = Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(
 registrationCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiEmployeeRegistrationcodesRegistrationCode>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiEmployeeRegistrationcodesRegistrationCodeQueryOptions(registrationCode,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiAdministratorusers = (
    createAdministratorUserRequest?: CreateAdministratorUserRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administratorusers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAdministratorUserRequest, signal
    },
      );
    }




export const getPostApiAdministratorusersMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusers>>, TError,{data?: CreateAdministratorUserRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusers>>, TError,{data?: CreateAdministratorUserRequest}, TContext> => {

const mutationKey = ['postApiAdministratorusers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministratorusers>>, {data?: CreateAdministratorUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiAdministratorusers(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministratorusersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministratorusers>>>
    export type PostApiAdministratorusersMutationBody = CreateAdministratorUserRequest | undefined
    export type PostApiAdministratorusersMutationError = ErrorResponse

    export const usePostApiAdministratorusers = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusers>>, TError,{data?: CreateAdministratorUserRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministratorusers>>,
        TError,
        {data?: CreateAdministratorUserRequest},
        TContext
      > => {
      return useMutation(getPostApiAdministratorusersMutationOptions(options), queryClient);
    }
    export const postApiAdministratorusersCompaniesCompanyIdInvoices = (
    companyId: number,
    params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/administratorusers/companies/${companyId}/invoices`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiAdministratorusersCompaniesCompanyIdInvoicesMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoices>>, TError,{companyId: number;params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoices>>, TError,{companyId: number;params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesParams}, TContext> => {

const mutationKey = ['postApiAdministratorusersCompaniesCompanyIdInvoices'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoices>>, {companyId: number;params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesParams}> = (props) => {
          const {companyId,params} = props ?? {};

          return  postApiAdministratorusersCompaniesCompanyIdInvoices(companyId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdministratorusersCompaniesCompanyIdInvoicesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoices>>>

    export type PostApiAdministratorusersCompaniesCompanyIdInvoicesMutationError = ErrorResponse

    export const usePostApiAdministratorusersCompaniesCompanyIdInvoices = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoices>>, TError,{companyId: number;params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdministratorusersCompaniesCompanyIdInvoices>>,
        TError,
        {companyId: number;params?: PostApiAdministratorusersCompaniesCompanyIdInvoicesParams},
        TContext
      > => {
      return useMutation(getPostApiAdministratorusersCompaniesCompanyIdInvoicesMutationOptions(options), queryClient);
    }
    /**
 * @deprecated
 */
export const getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode = (
    registrationCode: string,
 signal?: AbortSignal
) => {


      return axiosInstance<boolean>(
      {url: `/api/companies/current/employees/registrationcodes/${registrationCode}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeQueryKey = (registrationCode: string,) => {
    return [
    `/api/companies/current/employees/registrationcodes/${registrationCode}`
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(registrationCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeQueryKey(registrationCode);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>> = ({ signal }) => getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode(registrationCode, signal);





   return  { queryKey, queryFn, enabled: registrationCode !== null && registrationCode !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>>
export type GetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(
 registrationCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(
 registrationCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(
 registrationCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useGetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError = ErrorResponse>(
 registrationCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCode>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesRegistrationcodesRegistrationCodeQueryOptions(registrationCode,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteApiCompaniesCurrentEmployeesEmployeeIdPassword = (
    employeeId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/employees/${employeeId}/password`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentEmployeesEmployeeIdPasswordMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeIdPassword>>, TError,{employeeId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeIdPassword>>, TError,{employeeId: string}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentEmployeesEmployeeIdPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeIdPassword>>, {employeeId: string}> = (props) => {
          const {employeeId} = props ?? {};

          return  deleteApiCompaniesCurrentEmployeesEmployeeIdPassword(employeeId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentEmployeesEmployeeIdPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeIdPassword>>>

    export type DeleteApiCompaniesCurrentEmployeesEmployeeIdPasswordMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentEmployeesEmployeeIdPassword = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeIdPassword>>, TError,{employeeId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeIdPassword>>,
        TError,
        {employeeId: string},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentEmployeesEmployeeIdPasswordMutationOptions(options), queryClient);
    }
